import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/lib/utils";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Horizontal chip row for filtering the Funktioner queue by featureType name.
 * Rendered above the list only when the Funktioner tab is active and the
 * queue contains more than one distinct type — otherwise the filter is
 * pointless.
 */
export function FeatureTypeFilterChips(t0) {
  const $ = _c(18);
  const {
    counts,
    active,
    onChange,
    totalCount
  } = t0;
  if (counts.length <= 1) {
    return null;
  }
  const chipClass = _temp;
  let t1;
  if ($[0] !== onChange) {
    t1 = () => onChange(null);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = active === null;
  let t3;
  if ($[2] !== t2) {
    t3 = chipClass(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3 || $[6] !== totalCount) {
    t4 = /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: t1,
      className: t3,
      children: ["Alla \xB7 ", totalCount]
    });
    $[4] = t1;
    $[5] = t3;
    $[6] = totalCount;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== active || $[9] !== counts || $[10] !== onChange) {
    let t6;
    if ($[12] !== active || $[13] !== onChange) {
      t6 = t7 => {
        const {
          name,
          count
        } = t7;
        return /*#__PURE__*/_jsxs("button", {
          type: "button",
          onClick: () => onChange(name),
          className: chipClass(active === name),
          children: [name, " \xB7 ", count]
        }, name);
      };
      $[12] = active;
      $[13] = onChange;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = counts.map(t6);
    $[8] = active;
    $[9] = counts;
    $[10] = onChange;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = /*#__PURE__*/_jsxs("div", {
      className: "flex flex-wrap gap-1.5 border-b px-4 py-2",
      children: [t4, t5]
    });
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp(isActive) {
  return cn("whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-medium transition-colors", isActive ? "border-brand bg-brand text-white" : "border-gray-200 bg-white text-gray-700 hover:border-brand/50 hover:bg-brand/5");
}